import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { CurrencyService } from 'src/app/services/currency.service';
import { Currency, FxService } from 'src/app/services/fx.service';

@Pipe({
  name: 'toCustomItfgCurrency',
  standalone: false,
  pure: false,
})
export class ToCustomItfgCurrencyPipe
  extends CurrencyPipe
  implements PipeTransform {
  private fxService = inject(FxService);
  private currencyService = inject(CurrencyService);

  override transform(
    value: number | string | null | undefined,
    sourceCurrency: Currency = Currency[this.currencyService.defaultCurrency.getValue().code as keyof typeof Currency],
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo: string = '1.2-2',
    locale?: string,
    disableExchange: boolean = false
  ): any {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return null;
    }

    const numValue = Number(value);
    let displayCurrency = sourceCurrency;
    let displayAmount = numValue;

    if (disableExchange === false) {
      displayCurrency = this.fxService.displayCurrency();
      displayAmount = this.fxService.convert(
        numValue,
        sourceCurrency,
        displayCurrency
      );
    }

    const result = super.transform(
      displayAmount,
      displayCurrency,
      display,
      digitsInfo,
      locale
    );

    return result?.replace(',', '.') || null;
  }
}